const DISTRIBUTION_STAFF_ROLES = new Set(['ADMIN', 'STAFF']);

export const getDistributionTeamRole = (user) =>
  String(user?.team_user_role_id || user?.teamUserRoleId || user?.role || '')
    .trim()
    .toUpperCase();

export const isDistributionIndividual = (user) =>
  user?.is_individual === true || user?.is_individual === 1;

export const isDistributionStaffUser = (user) => {
  if (user?.account_type === 'ADMIN' || user?.is_admin) return true;

  const role = getDistributionTeamRole(user);
  if (role) return DISTRIBUTION_STAFF_ROLES.has(role);

  return !user?.is_driver;
};

export const isDistributionDriverOnlyUser = (user) =>
  user?.account_type === 'TEAM-STAFF' &&
  Boolean(user?.is_driver) &&
  !isDistributionStaffUser(user);

/**
 * Home delivery / distributions access.
 *
 * Source of truth is plan capability (`hasHomeDelivery` from the careit matrix:
 * Food Delivery Pro, or Food Mover Lite/Pro with the Home Delivery add-on).
 * No separate super-admin checkbox — grant the right plan instead.
 */
export const canUseDistributions = ({ user, hasHomeDelivery }) =>
  Boolean(hasHomeDelivery && !isDistributionIndividual(user));

export const canUseDistributionAdmin = (args) =>
  canUseDistributions(args) && isDistributionStaffUser(args.user);

export const canUseDistributionDriverBoard = (args) =>
  canUseDistributions(args) &&
  (args.user?.account_type === 'TEAM-STAFF' ||
    isDistributionStaffUser(args.user) ||
    canUseDistributionAdmin(args));
